import { render, staticRenderFns } from "./FeedbackManagerList.vue?vue&type=template&id=1b570a2d&scoped=true&"
import script from "./FeedbackManagerList.vue?vue&type=script&lang=js&"
export * from "./FeedbackManagerList.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackManagerList.vue?vue&type=style&index=0&id=1b570a2d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b570a2d",
  null
  
)

export default component.exports